/*
|-------------------------------------------------------------------------------
| Services for General Axios Endpoint Queries
|-------------------------------------------------------------------------------
*/
import * as helpers from "../utilities/helperUtils"
import { strapiInstance as strapiInstance } from "./axios/axiosInstance";

strapiInstance.defaults.headers.common['Content-Type'] = 'application/json';

export default {
    GET_STRAPI (endpoint, params = {}) {
        return strapiInstance.get(helpers.buildUrl(endpoint, helpers.encodeQueryData(params)));
    }
}

